import { Component, OnInit } from '@angular/core'
import { CpmService } from '../../../service/cpm.service'
import { StoreService } from '../../../service/store.service'
import { Subscription } from 'rxjs/Subscription'
import { ActivatedRoute } from '@angular/router'

@Component({
  selector: 'app-dividend-payment',
  templateUrl: './dividend-payment.component.html',
  styleUrls: ['./dividend-payment.component.scss']
})
export class DividendPaymentComponent implements OnInit {
  showDate
  listTableDividend
  listHeadDividend = []
  subscription: Subscription
  constructor(
    private cpmService: CpmService,
    private store: StoreService,
    private activatedRoute: ActivatedRoute
  ) {}

  ngOnInit() {
    this.listHeadDividend = ['X-Date', 'Dividend per share', 'Type']
    this.listTableDividend = []
    const { symbol } = this.activatedRoute.snapshot.params
    if (symbol !== undefined) {
      this.getDividendData(symbol)
    } else {
      this.subscription = this.store
        .getSecurityProfileNewResultObservable()
        .subscribe(response => {
          if (!response) {
            return
          }
          this.getDividendData(response['securitySymbol'])
        })
    }
  }

  getDividendData(symbol) {
    this.cpmService.getDividend(symbol, 5).then(obj => {
      this.listTableDividend = []
      obj.map(data => {
        this.listTableDividend.push(data)
      })
    })
  }

  noDividendData() {
    return this.listTableDividend.length > 0 ? false : true
  }

  isSDType(data) {
    return data.caType === 'SD'
  }

  showStartDateEndDate(startDate, endDate) {
    if (startDate != null && endDate != null) {
      return 1
    } else if (startDate != null && endDate == null) {
      return 2
    } else if (startDate == null && endDate != null) {
      return 3
    } else {
      return 4
    }
  }
}



// WEBPACK FOOTER //
// /opt/alm/jenkins/workspace/mis-cpm/mis-cpm-prod-front/src/app/securities-level/corporate-action/dividend-payment/dividend-payment.component.ts